import {
  Box,
  FormHelperText,
  Grid2 as Grid,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import PaisResultsGrid from "../../buildingComponents/PaisResultsGrid";
import {
  addProductRow,
  setEnlargeGrid,
  setPaisState,
} from "../../../store/actions/permitFormActions/paisStateActions";
import { generateCustomId } from "../utils/paisFunctions";

const SearchKeywordFields = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const {
    enlargeGrid,
    foundProducts,
    addDisabled,
    selectedProductRow,
    noProductError,
    loadingData,
    freeSearch,
    productRows,
    rowsPerPage,
  } = useSelector((state) => state.paisState);

  const [searchDisabled, setSearchDisabled] = useState(false);
  // const [loadingData, setLoadingData] = useState(false);
  // const [selectedProductRow, setSelectedProductRow] = useState(null);
  // const [foundProducts, setFoundProducts] = useState([]);
  // const [noProductError, setNoProductError] = useState("");
  // const [addDisabled, setAddDisabled] = useState(false);

  const dispatch = useDispatch();

  const handleAddKeywordProduct = async () => {
    const categorySplit = selectedProductRow?.category_code?.split("_");

    const category = categorySplit?.[0];
    const subCategory = categorySplit?.[1];

    const newID = generateCustomId();
    const productObject = {
      id: newID,
      category: category,
      subCategory: subCategory,
      categoryLabel: selectedProductRow?.category,
      subCategoryLabel: selectedProductRow?.subcategory,
      description: selectedProductRow?.sub_description,
      expiry: selectedProductRow?.sub_expiration_date,
      flNumber: selectedProductRow?.sub_fl_number,
      instructions: selectedProductRow?.sub_instructions,
      manAddress: selectedProductRow?.product_manufacturer_address,
      manEmail: selectedProductRow?.product_manufacturer_email,
      manPhone: selectedProductRow?.product_manufacturer_phone,
      manufacturer: selectedProductRow?.product_manufacturer,
      model: selectedProductRow?.sub_model_number_or_name,
      note: selectedProductRow?.sub_note,
      version: selectedProductRow?.code_version,
      unsaved: true,
    };

    const newCount = Math.ceil((productRows.length + 1) / rowsPerPage);

    dispatch(setPaisState({ page: newCount, selectedProductRow: null }));

    dispatch(addProductRow(productObject));
  };

  const handleFreeSearchProduct = async () => {
    try {
      await dispatch(
        setPaisState({ loadingData: true, selectedProductRow: null })
      );
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/pais/get-freeSearch-products`,
        {
          currentSession: currentSession,
          searchText: freeSearch,
        },
        { withCredentials: true }
      );

      if (resp?.data?.success) {
        await dispatch(setPaisState({ foundProducts: resp?.data?.data }));

        setSearchDisabled(true);
      } else {
        await dispatch(
          setPaisState({
            foundProducts: [],
            noProductError: resp?.data?.message,
          })
        );
      }
    } catch (error) {
    } finally {
      await dispatch(setPaisState({ loadingData: false }));
      setTimeout(() => {
        dispatch(
          setPaisState({
            noProductError: "",
          })
        );
      }, 3000);
    }
  };

  return (
    <Grid container spacing={1} mt={2}>
      <Grid size={{ md: 6 }}>
        <TextField
          fullWidth
          variant="filled"
          label="Enter keywords"
          size="small"
          name="freeSearch"
          value={freeSearch || ""}
          onChange={(e) => {
            if (searchDisabled) {
              setSearchDisabled(false);
            }
            dispatch(setPaisState({ freeSearch: e.target.value }));
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            },
          }}
        />
      </Grid>
      <Grid size={{ md: 6 }} alignSelf="center">
        <LoadingButton
          sx={{ mr: 1 }}
          onClick={handleFreeSearchProduct}
          disabled={freeSearch?.length < 3 || searchDisabled}
          loading={loadingData}
          variant="contained"
          color="warning"
        >
          Search
        </LoadingButton>
        <LoadingButton
          onClick={handleAddKeywordProduct}
          disabled={
            freeSearch?.length < 3 || !selectedProductRow || addDisabled
          }
          loading={loadingData}
          variant="contained"
          color="success"
        >
          Add Product
        </LoadingButton>
        {!enlargeGrid && foundProducts?.length > 0 ? (
          <Tooltip title="Maximize Table">
            <IconButton
              sx={{ ml: 1 }}
              onClick={() => {
                dispatch(setEnlargeGrid(true));
                dispatch(setPaisState({ selectedProductRow: null }));
              }}
            >
              <FullscreenIcon sx={{ fontSize: 28 }} />
            </IconButton>
          </Tooltip>
        ) : (
          <></>
        )}
      </Grid>
      <Grid size={{ xs: 12 }}>
        {foundProducts?.length > 0 && !enlargeGrid ? (
          <>
            <FormHelperText
              sx={{ color: "#004976", fontWeight: "bold" }}
              align="center"
            >
              Inserting a product into the form is as simple as clicking on the
              corresponding row and then clicking "Add Product."
            </FormHelperText>
            <Box>
              <PaisResultsGrid />
            </Box>
          </>
        ) : foundProducts?.length > 0 && enlargeGrid ? (
          <></>
        ) : (
          <Typography variant="body2" color="error" align="center" my={2}>
            {noProductError}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default SearchKeywordFields;
